module.exports = "/_next/static/images/d0ff6d945b91da4b017c4fba786aad9a-card-lg.png";